import  React from 'react';
import { config } from "../../config";
import { Container, Col, Row } from "reactstrap"
import { addBodyClasses} from "../utils";

const queryString = require('query-string');

function WebRetroDownload() {
  const parsed = queryString.parse(window.location.search);
  const edition = parsed.edition || 'measure';
  const code = parsed.code;

  const downloadUrl = `${config.CONTRIBUTOR_API_ENDPOINT}/download?edition=${edition}&code=${code}`;

  addBodyClasses(['download-page'])();

  return (
    <Container fluid="sm">
      <Row>
        <Col>
          <img className="tick-icon" src="/img/circle-tick-white.svg" alt="Welcome to MSR" />
          <h1>Welcome to MSR</h1>
          <p>Your account has been created. Tap below to install the MSR app where you'll be able to redeem
            your payment plus your bonus as well as participate in more jobs.</p>
          <div className="action-button">
            <a className="btn btn-primary" href={downloadUrl}>Download MSR</a>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default WebRetroDownload;
